export default {
  receipt: (code) =>
    `cu/SMIS_CU/SchoolManagement_getReceiptReport?receiptNo=${code}`,
  invoice: (code) =>
    `cu/SMIS_CU/SchoolManagement_getProfomaInvoice?registrationNo=${code}`,
  billingAddresses: `profile/billing-address`,
  removeBillingAddresses: (param) =>
    `profile/billing-address?${buildQuery(param)}`,
};

function buildQuery(param) {
  const query = new URLSearchParams(param);
  return query.toString();
}
